import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm] = useState({ identifier: '', password: '', adminKey: '' });
  const [busy, setBusy] = useState(false);
  const [showKey, setShowKey] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.identifier, form.password, form.adminKey);
      toast.success('Connexion réussie');
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Erreur de connexion';
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        {/* Logo */}
        <div style={S.logoRow}>
          <div style={S.logoBadge}>TOKKAM</div>
          <div style={S.logoSub}>Admin Dashboard</div>
        </div>

        <div style={S.divider}/>

        <form onSubmit={handleSubmit} style={S.form}>
          <label style={S.label}>Email ou identifiant administrateur</label>
          <input
            style={S.input}
            type="text"
            placeholder="Email ou identifiant"
            value={form.identifier}
            onChange={e => setForm(f => ({...f, identifier: e.target.value}))}
            required
          />

          <label style={S.label}>Mot de passe</label>
          <input
            style={S.input}
            type="password"
            placeholder="••••••••"
            value={form.password}
            onChange={e => setForm(f => ({...f, password: e.target.value}))}
            required
          />

          <div style={S.toggleRow} onClick={() => setShowKey(x => !x)}>
            <span style={S.toggleIcon}>{showKey ? '▾' : '▸'}</span>
            <span style={S.toggleLabel}>Clé d'accès admin (optionnel)</span>
          </div>

          {showKey && (
            <input
              style={{...S.input, marginTop: 4}}
              type="password"
              placeholder="TOKKAM-ADMIN-****"
              value={form.adminKey}
              onChange={e => setForm(f => ({...f, adminKey: e.target.value}))}
            />
          )}

          <button type="submit" style={S.btn} disabled={busy}>
            {busy ? 'Connexion...' : '→ Se connecter'}
          </button>
        </form>

        <div style={S.footer}>
          <span style={S.footerDot}/> HTTPS · JWT · Session sécurisée
        </div>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh',
    background: '#0d1b3e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
    padding: 20,
  },
  card: {
    width: '100%',
    maxWidth: 380,
    background: '#10224a',
    border: '1px solid rgba(255,255,255,.14)',
    borderRadius: 10,
    padding: '32px 28px',
  },
  logoRow: { textAlign: 'center', marginBottom: 4 },
  logoBadge: {
    display: 'inline-block',
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: 4,
    color: '#f5a623',
    background: 'rgba(88,166,255,.08)',
    border: '1px solid rgba(88,166,255,.2)',
    padding: '6px 20px',
    borderRadius: 6,
  },
  logoSub: { fontSize: 11, color: 'rgba(255,255,255,.58)', marginTop: 6, letterSpacing: 1 },
  divider: { height: 1, background: 'rgba(255,255,255,.10)', margin: '20px 0' },
  form: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 11, color: 'rgba(255,255,255,.72)', letterSpacing: '.5px', textTransform: 'uppercase', marginTop: 4 },
  input: {
    background: '#0d1b3e',
    border: '1px solid rgba(255,255,255,.14)',
    borderRadius: 6,
    color: '#ffffff',
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: 13,
    padding: '9px 12px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  toggleRow: {
    display: 'flex', alignItems: 'center', gap: 6,
    cursor: 'pointer', color: 'rgba(255,255,255,.58)', fontSize: 11,
    marginTop: 4, userSelect: 'none',
  },
  toggleIcon: { color: '#f5a623' },
  toggleLabel: { letterSpacing: '.3px' },
  btn: {
    marginTop: 12,
    background: '#1e4db7',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: 13,
    fontWeight: 700,
    padding: '11px',
    cursor: 'pointer',
    letterSpacing: '.5px',
    transition: 'background .15s',
  },
  sep: { textAlign: 'center', color: 'rgba(255,255,255,.58)', fontSize: 11, margin: '14px 0 10px' },
  demoBtn: {
    width: '100%',
    background: 'rgba(255,255,255,.04)',
    border: '1px solid rgba(255,255,255,.14)',
    borderRadius: 6,
    color: 'rgba(255,255,255,.72)',
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: 12,
    padding: '9px',
    cursor: 'pointer',
  },
  footer: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    fontSize: 10,
    color: 'rgba(255,255,255,.58)',
  },
  footerDot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#22c55e', boxShadow: '0 0 6px #22c55e',
    display: 'inline-block',
  },
};
